import React from "react";
import HistroyTable from "../../Componenets/CommanTable/HistroyTable/HistroyTable";

interface LeadProps {
  LeadData: any[];
  isLoading?: boolean;
}


const columns = [
  { field: "lead_id", headerName: "Lead ID" },
  { field: "date", headerName: "Date" },
  { field: "status", headerName: "Status" },
  { field: "remark", headerName: "Remark" },
];

const HistroyView: React.FC<LeadProps> = ({ LeadData = [], isLoading }) => {
  if (isLoading) {
    return <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>;
  }


  const formattedData = LeadData.map((lead) => ({
    lead_id: lead.lead_id || "-",
    date: lead.created_on
      ? new Date(lead.created_on).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "-",
    status: lead.leadstatus
      ? lead.leadstatus.replace(/_/g, " ").replace(/\b\w/g, (l:any) => l.toUpperCase())
      : "-",
    remark: lead.source || "-", 
  }));

  return (
    <div style={{ padding: "20px 0px" }}>
      <HistroyTable
        columns={columns}
        data={formattedData}
        highlightRow={(row) => row.status === "Followup Pending"}
      />
    </div>
  );
};

export default HistroyView;
